export const findRightElement = (
  childCollection: HTMLCollection,
  rightBorder: number,
  offset: number,
): HTMLElement | null => {
  const childList = Array.from(childCollection);

  const candidate = childList.find((child: HTMLElement) => {
    const rightX = child.offsetLeft - offset + child.offsetWidth;

    return rightX > rightBorder;
  });

  return (candidate as HTMLElement) || null;
};
